/* Breasties "Match 3 shades" pop-up.
   A/B partner of the scratch card: only opens for visitors whose
   localStorage bzPopupVariant is "match3" (set by the inline script in
   sections/bz-match3.liquid). 3x3 gold tiles hide nipple covers; the
   board always holds exactly three of one shade, so everyone wins by
   tap 9. Then it collects an email. The discount code is never on the
   page: it arrives in the Judge.me Email welcome flow. */
(function () {
  var SHADES = [
    { name: 'Ivory', hex: '#F0D8C4' },
    { name: 'Latte', hex: '#D8AE8A' },
    { name: 'Honey', hex: '#BF8857' },
    { name: 'Toffee', hex: '#8C5A36' },
    { name: 'Espresso', hex: '#4B2C1E' }
  ];

  // Board: the winning shade x3, the other four shades as 2,2,1,1, shuffled.
  // No other shade can reach 3, and with all 9 tiles up the winner has 3.
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function makeBoard() {
    var winner = Math.floor(Math.random() * SHADES.length);
    var others = shuffle(SHADES.map(function (_, i) { return i; }).filter(function (i) { return i !== winner; }));
    var counts = [2, 2, 1, 1], board = [winner, winner, winner];
    others.forEach(function (s, k) { for (var n = 0; n < counts[k]; n++) board.push(s); });
    return { board: shuffle(board), winner: winner };
  }
  window.BzMatch3 = { shades: SHADES, makeBoard: makeBoard };

  var root = document.querySelector('[data-bz-match3]');
  if (!root) return;
  var KEY = 'bzMatch3', d = root.dataset;
  var design = d.design === '1', posted = d.posted === '1';
  function variant() { try { return localStorage.getItem('bzPopupVariant') || ''; } catch (e) { return ''; } }
  if (!design && variant() !== 'match3') return;

  var prize = { title: '', sub: '' };
  try { prize = JSON.parse(document.querySelector('[data-bz-m3-prize]').textContent); } catch (e) {}

  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(KEY) || '{}');
      if (!design) localStorage.setItem(KEY, JSON.stringify(val));
    } catch (e) { return {}; }
  }
  var state = (design ? {} : store(true)) || {};
  if (!Array.isArray(state.board) || state.board.length !== 9 || state.winner == null) {
    var b = makeBoard(); state.board = b.board; state.winner = b.winner; state.revealed = []; state.won = false;
  }
  if (!Array.isArray(state.revealed)) state.revealed = [];

  // Lightweight events for later use (no analytics tool reads them today).
  function track(name) {
    var p = { game: 'match3', variant: variant() || 'match3', page: location.pathname, shade: state.won || posted ? SHADES[state.winner].name : null };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bz_' + name, p); } catch (e) {}
    try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: 'bz_' + name }, p)); } catch (e) {}
  }

  var grid = root.querySelector('[data-bz-m3-grid]');
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tile]'));
  var winEl = root.querySelector('[data-bz-m3-win]');
  var locked = false, played = false;

  function paintTile(i) {
    var t = tiles[i], sh = SHADES[state.board[i]];
    t.querySelector('.bz-m3__cover').style.setProperty('--c', sh.hex);
    t.querySelector('.bz-m3__name').textContent = sh.name;
    t.classList.add('is-up');
    t.setAttribute('aria-label', 'Tile ' + (i + 1) + ', ' + sh.name);
    t.setAttribute('aria-disabled', 'true');
  }
  function note() {
    var n = root.querySelector('[data-bz-m3-note]');
    if (n) n.value = 'Match 3: ' + SHADES[state.winner].name + ' · ' + prize.title;
  }
  function step(name) {
    root.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.dataset.step !== name; });
    if (name === 'claim') setTimeout(function () { var i = root.querySelector('#BzMatch3Email'); if (i) i.focus(); }, 60);
  }
  function confetti() {
    var box = root.querySelector('[data-bz-m3-confetti]');
    if (!box || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    box.innerHTML = '';
    for (var i = 0; i < 36; i++) {
      var s = document.createElement('span'), a = Math.random() * Math.PI * 2, r = 90 + Math.random() * 170;
      s.className = 'bz-m3__bit';
      s.style.setProperty('--dx', Math.round(Math.cos(a) * r) + 'px');
      s.style.setProperty('--dy', Math.round(Math.sin(a) * r - 40) + 'px');
      s.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
      s.style.animationDelay = Math.round(Math.random() * 120) + 'ms';
      box.appendChild(s);
    }
    setTimeout(function () { box.innerHTML = ''; }, 1600);
  }
  function lock() {
    locked = true;
    tiles.forEach(function (t) { t.setAttribute('aria-disabled', 'true'); });
  }
  function win(animate) {
    lock();
    var w = state.winner;
    tiles.forEach(function (t, i) { if (state.board[i] === w && state.revealed.indexOf(i) > -1) t.classList.add('is-match'); });
    grid.classList.add('is-won');
    winEl.textContent = '3 × ' + SHADES[w].name + '! ' + prize.title;
    var rv = root.querySelector('[data-bz-m3-reveal]'); if (rv) rv.hidden = true;
    note();
    if (!state.won) { state.won = true; store(false, state); track('popup_win'); }
    if (animate) { confetti(); setTimeout(function () { step('claim'); }, 1200); }
    else step('claim');
  }
  function flip(i) {
    if (locked || state.revealed.indexOf(i) > -1) return;
    if (!played) { played = true; track('popup_play'); }
    state.revealed.push(i); paintTile(i); store(false, state);
    var n = state.revealed.filter(function (k) { return state.board[k] === state.board[i]; }).length;
    if (n >= 3) win(true);
  }
  tiles.forEach(function (t, i) { t.addEventListener('click', function () { flip(i); }); });
  var rv = root.querySelector('[data-bz-m3-reveal]');
  if (rv) rv.addEventListener('click', function () {
    if (locked) return;
    if (!played) { played = true; track('popup_play'); }
    tiles.forEach(function (_, i) { if (state.revealed.indexOf(i) < 0) { state.revealed.push(i); paintTile(i); } });
    store(false, state); win(true);
  });

  // Restore a board already in play.
  state.revealed.forEach(paintTile);
  if (state.won) win(false);
  note();

  var lastFocus = null, opened = false;
  function open(force) {
    if (opened && !force) return;
    opened = true; lastFocus = document.activeElement;
    root.hidden = false; document.documentElement.classList.add('bz-m3-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    if (!design) { state.seen = Date.now(); store(false, state); }
    var x = root.querySelector('.bz-m3__x'); if (x) x.focus();
    track('popup_view');
  }
  function close() {
    root.classList.remove('is-open'); document.documentElement.classList.remove('bz-m3-lock');
    setTimeout(function () { root.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelectorAll('[data-bz-m3-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  // ---------- claim ----------
  // Posts the Shopify customer form (tagged "newsletter" + "match-3"), which
  // subscribes them and starts the Judge.me Email welcome flow. The page
  // reloads to the "check your inbox" step.
  var form = document.getElementById('BzMatch3Form');
  if (form) form.addEventListener('submit', function () {
    note(); state.claimed = true; store(false, state); track('popup_signup_submit');
  });

  // ---------- when to open ----------
  if (posted) { step('code'); open(true); track('popup_signup_success'); return; }
  if (d.errors === '1' && !design) { step('claim'); open(true); return; }
  if (design) {
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) open(true); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
    return;
  }
  var days = (+d.days || 14) * 864e5;
  if (state.claimed || (state.seen && Date.now() - state.seen < days)) return;
  if (+d.delay > 0) setTimeout(open, +d.delay * 1000);
  if (+d.scroll > 0) window.addEventListener('scroll', function onS() {
    var p = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
    if (p >= +d.scroll) { window.removeEventListener('scroll', onS); open(); }
  }, { passive: true });
  if (d.exit === 'true') document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
})();
